const m1Factor = {
    'cohesive': 0.7,
    'noncohesive': 0.8
}

export default m1Factor;